import { DateTime } from 'luxon';

import { getUserId, getMerchantId } from './user.service';
import { request } from './request';

export async function getOltpTransactions(
  startDate,
  endDate,
  pageNumber = 1,
  abortController = null,
  handleErrorResponse = null,
  showToastOnError = true,
  suppressTealiumEvent = false,
) {
  const userId = getUserId();
  const merchantId = getMerchantId();
  const qsFromDate = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd HH:mm:ss');
  const qsToDate = DateTime.fromJSDate(endDate).toFormat('yyyy-MM-dd HH:mm:ss');
  const res = await request(
    `oltp-transactions?userReference=${userId}&merchantID=${merchantId}&localTransactionFromDate=${qsFromDate}&localTransactionToDate=${qsToDate}&pageNumber=${pageNumber}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    null,
    showToastOnError,
    suppressTealiumEvent,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res.status === 200) {
    return res.result;
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse(
      'error response from the oltp-transactions GET endpoint',
      true,
      suppressTealiumEvent,
      res,
    );
  }
}
